import { IState } from '../../store';
import { ISidebar } from '../../types/sidebar';

export const selectSidebarData = (state: IState): ISidebar[] => state.offerData.sidebar;
